@if(count() > 0){   
  <count-badge [count]="count()"></count-badge>
}

<span role="button" class="material-icons-sharp font-8 mt-1 primary-text-100 ms-3" (click)="openNotifications()">notifications_none</span>
